import { useContext } from 'react';

const useSelectedFilterSet = Context => {
  const {
    state: { filterSets, selectedFilterSetId }
  } = useContext(Context);

  return filterSets?.[selectedFilterSetId] || null;
};

export default useSelectedFilterSet;
